import { ADD_SUGGEST_GOLF, ADD_SUGGEST_GOLF_SUCCESS, ADD_SUGGEST_GOLF_ERROR, ADD_SUGGEST_GOLF_EMPTY } from '../../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const AddSuggestGolf = (state = initialState, action) => {
  switch (action.type) {
    case ADD_SUGGEST_GOLF:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case ADD_SUGGEST_GOLF_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case ADD_SUGGEST_GOLF_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case ADD_SUGGEST_GOLF_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default AddSuggestGolf;
